import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=69923d37"
const script = {}
script.render = render

export default script